/**
 * временное решение на базе существующих стилей
 *
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React from "react";
import styles from "./textarea.module.sass";
import classNames from "classnames";
import sass from "components-new/InputTemp/input.module.sass";
import cn from "classnames";

interface ITextarea extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
	autosize?: boolean;
	error?: boolean;
	errorText?: string;
}

const TextArea: React.FC<ITextarea> = ({
	autosize = false,
	errorText,
	error,
	label,
	style,
	maxLength,
	required = false,
	onChange,
	...rest
}) => {
	const change = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		e.target.scrollTop = e.target.scrollHeight;
		onChange && onChange(e);
		// const targetArray = e.target.value.split(/[\n\r]/)
		if (autosize) {
			e.target.style.height = "0";
			e.target.style.height = e.target.scrollHeight + 2 + "px";
			// e.target.style.height = targetArray.length*14+'px';
		}
	};
	return (
		<div className={styles["input-wrp"]}>
			<textarea
				required={required}
				maxLength={maxLength}
				onChange={change}
				style={{ ...style, ...(!!maxLength && { paddingBottom: 30 }) }}
				className={classNames(styles.input, styles.area, { [styles.error]: error || errorText })}
				{...rest}
			/>
			{/*{label && <span className={styles.name}>{label}{required && <sup className={styles.required}>*</sup>}</span>}*/}
			{(error || errorText || label) && (
				<div className={styles.caption}>
					{label && (
						<p className={cn(error || errorText ? styles.labelError : styles.label)}>
							{label}
							{required && <span className={styles.required}> *</span>}
						</p>
					)}
					{errorText && <p className={sass["error-input-title"]}>{errorText || errorText}</p>}
				</div>
			)}
			{!!maxLength && <span className={styles["area-limit"]}>до {maxLength} символов</span>}
		</div>
	);
};

export default TextArea;
